import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DATA_QA } from '../../../helpers/data-qa';
import { INewsForgeTranslationContent } from '../../../models/news-forge.models';
import '../../../styles/news-forge.styles.scss';
import ReadyForExtractionIcon from '../news-forge-process-images/news-forge-ready-icon';
import InProgressExtractionIcon from '../news-forge-process-images/news-forge-inprogress-icon';

type Properties = {
	newsForgeContent: INewsForgeTranslationContent;
	isExtracting: boolean;
	isRegenerating?: boolean;
};

const NewsForgeOperationsContainer: FunctionComponent<Properties> = ({ newsForgeContent, isExtracting, isRegenerating }) => {
	const { t } = useTranslation();
	const targetUrl = newsForgeContent && newsForgeContent.target_url ? newsForgeContent.target_url.trim() : '';
	const hasURL = targetUrl.length > 0;

	return (
		<div className='news-forge-operations-container' data-qa={DATA_QA.NEWS_FORGE_OPERATIONS_CONTAINER}>
			{isExtracting && hasURL ? (
				<>
					<InProgressExtractionIcon />
					<span className='news-forge-info-label'>{t(isRegenerating ? 'regeneration_in_progress' : 'extraction_in_progress')}</span>
					<span className='news-forge-info-description-label'>
						{t(isRegenerating ? 'regeneration_disclaimer' : 'extraction_in_progress_description')}
					</span>
				</>
			) : (
				<>
					<ReadyForExtractionIcon />
					<span className='news-forge-info-label'>{t('provide_extraction_url')}</span>
				</>
			)}
		</div>
	);
};

export default NewsForgeOperationsContainer;
